export default {
    MYSELF_ONLY: 'myself-only',
    ME_AND_MY_PARTNER: 'me-and-my-partner',
    ONE_FAMILY: 'one-family',
    TWO_FAMILIES: 'two-families',
    THREE_FAMILIES: 'three-families',
    MORE_THAN_THREE_FAMILIES: 'more-than-three-families',
};
